"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("../constants/events");
const performanceEntryUtils_1 = require("../utils/performanceEntryUtils");
/**
 * Mark the end time of a dynamic event `eventName`, measure the interval
 * between the start and end times, and return an `EndEvent`.
 *
 * A custom `startEventName` can be provided to use a different event's start
 * time to measure the interval. This is useful for when several dynamic events
 * share the same start time.
 *
 * If the dynamic event start is not found, return an empty object.
 *
 * @param eventName - name of the dynamic event
 * @param [startEventName] - Name of the event to use for the start time of the
 *   interval. `eventName` will be used if not provided.
 *
 * @returns An `EndEvent` object, or `null` if the start event is not found or
 *   if we're not in a browser environment.
 */
function createDynamicEndEvent(eventName, startEventName) {
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return null;
    const { performance: perf } = window;
    const eventEndName = `${eventName}${events_1.DYNAMIC_EVENT_END_MARK_SUFFIX}`;
    const eventDurationName = `${eventName}${events_1.DYNAMIC_EVENT_DURATION_SUFFIX_NEW}`;
    const startName = startEventName || eventName;
    const hasBeginMark = perf.getEntriesByName(startName).length;
    if (!hasBeginMark) {
        console.warn(`Attempt to end a dynamic event interval ${eventName} before it was started.`);
        return null;
    }
    perf.mark(eventEndName);
    perf.measure(eventDurationName, startName, eventEndName);
    const eventDurationPerfEntry = (0, performanceEntryUtils_1.getLatestPerfEntryByName)(eventDurationName);
    // purge performance entries we've created
    perf.clearMarks(eventEndName);
    return (0, performanceEntryUtils_1.perfEntryToEventEndObj)(eventDurationPerfEntry);
}
exports.default = createDynamicEndEvent;
